import './image-slider.scss';
import 'slick-carousel';
import 'magnific-popup';
export default () => {
  $('.js-image-slider').slick({
    rows: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true
  });
  $('.popup-youtube').magnificPopup({
    type: 'iframe'
  });
  $('.image-popup-no-margins').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    closeBtnInside: false,
    fixedContentPos: true,
    mainClass: 'mfp-no-margins mfp-with-zoom',
    image: {
      verticalFit: true
    },
    zoom: {
      enabled: true,
      duration: 300
    }
  });
};